export const PROVIDER_TATARSTAN = 10000;
export const PROVIDER_NIZHNY = 10010;

export const EXTERNAL_SUPPLIER = [PROVIDER_TATARSTAN, PROVIDER_NIZHNY];
